<template>
  <div v-bind:style="`width: ${width}%`" class="developer-key">
    <div class="form-group">
      <label class="control-label" v-bind:for="id" v-html="title"></label>
      <div class="developer-key__description text-muted" v-html="description"></div>
      <div class="input-group">
        <input class="mula-form-group__input form-control" readonly type="text" v-bind:value="value" :id="id">
        <div id="copy-button"
             :class="copyButtonClass()"
             :data-clipboard-text="value">
          <span class="input-group-text">COPY</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import Clipboard from 'clipboard'

  export default {
    methods: {
      copyButtonClass () { return ['input-group-append js-copy-button', `js-${this.id}_${_.snakeCase(this.title)}`] }
    },
    mounted () {
      this.$nextTick(() => {
        const clipboard = new Clipboard(`.js-${this.id}_${_.snakeCase(this.title)}`)
        clipboard.on('success', (evt) => {
          this.$snackbar.open({
            message: this.title + ' copied to clipboard',
            type: 'is-success',
            position: 'is-bottom',
            queue: false
          })
        })
      })
    },
    name: 'DeveloperKey',
    props: {
      title: {
        type: String,
        required: true
      },
      description: {
        type: String
      },
      id: {
        type: String,
        default: 'provide_id'
      },
      value: {
        required: true
      },
      width: {
        default: 45,
        type: Number
      }
    }
  }
</script>

<style lang="scss">
@import "../styles/theme.scss";

.developer-key {
  width: 45%;

  .control-label {
    margin-bottom: 0rem;
  }

  .developer-key__description {
    font-size: 12px;
  }

  input[readonly] {
    background: $background-white;
    border: 1px solid $border-color-lighten;
    border-right: none;
    padding: .5rem;
    outline: none;
  }

  input:focus, input:active {
    box-shadow: none;
  }

  .input-group-text {
    background: #fff;
    border-left: none;
    border-color: $border-color-lighten;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DeveloperKey.vue